<template>
  <button class="toolbar-btn anim-color" :class="classes">
    <slot />
  </button>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    isActive: Boolean
  },

  setup (props) {
    const { getters } = useStore()

    const isMagenta = computed(() => getters.isMagenta)

    const classes = computed(() => {
      const prefix = props.isActive ? '' : 'md:hover:'

      return isMagenta.value ? `${prefix}bg-hover-book ${prefix}text-black` : `${prefix}bg-main-color ${prefix}text-white`
    })

    return {
      // ref
      // data
      // computed
      classes,
      isMagenta
      // function
    }
  }
})
</script>
